import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import { auth0_config } from './lib/auth0'
import App from './App.tsx'

import metric from '../../util/metric.js'
import './index.css'

metric.init()

function Auth0_wrapper({children}: {children: React.ReactNode}) {
  const navigate = useNavigate()
  return (
    <Auth0Provider
      domain={auth0_config.domain}
      clientId={auth0_config.client_id}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0_config.audience,
      }}
      onRedirectCallback={(app_state) => {
        navigate(app_state?.returnTo || '/', {replace: true})
      }}
    >
      {children}
    </Auth0Provider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0_wrapper>
        <App />
      </Auth0_wrapper>
    </BrowserRouter>
  </React.StrictMode>,
)